import { useMemo } from 'react';

import { useSysadmin } from '@air/sysadmin';

import { IMPORT_SOURCES, INTERNAL_IMPORT_SOURCES } from '~/constants/importSource';
import { useExcludedIntegrationsFlag } from '~/hooks/flags/useExcludedIntegrationsFlag';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type ImportSourceType } from '~/utils/ImportUtils';

export const useExposeImportSources = () => {
  const { isInternal } = useSysadmin();
  const { showSharePointImportSource } = useFeatureFlags();
  const { showFrameIoImportSource } = useTemporaryFeatureFlags();
  const { excludedImportSources } = useExcludedIntegrationsFlag();

  const exposeImportSources = useMemo<ImportSourceType[]>(() => {
    const sources: ImportSourceType[] = [...IMPORT_SOURCES];

    if (isInternal) {
      sources.push(...INTERNAL_IMPORT_SOURCES);
    } else {
      if (showSharePointImportSource) {
        sources.push('sharePoint');
      }

      if (showFrameIoImportSource) {
        sources.push('frameio');
      }
    }

    return sources.filter((source) => !excludedImportSources.includes(source));
  }, [excludedImportSources, isInternal, showFrameIoImportSource, showSharePointImportSource]);

  return { exposeImportSources };
};
